import { z } from "zod";

import { Options } from "../pagination";

import { zSchema as zFilterSchema } from "./filter";
import { zSchema as zSortSchema } from "./sort";

function zSchema<FieldNames extends z.ZodEnum<[string, ...string[]]>>(fieldNames: FieldNames) {
  return z
    .object({
      filter: zFilterSchema,
      sort: zSortSchema(fieldNames),
    })
    .partial()
    .merge(
      z.object({
        pagination: Options.zSchema,
      }),
    );
}
type Schema<FieldNames extends z.ZodEnum<[string, ...string[]]>> = z.infer<
  ReturnType<typeof zSchema<FieldNames>>
>;

export { zSchema };
export type { Schema };
